import { render, staticRenderFns } from "./SuggestionMare.vue?vue&type=template&id=afd418fc&"
import script from "./SuggestionMare.vue?vue&type=script&lang=js&"
export * from "./SuggestionMare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports